
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequirefc28"];
var parcelRegister = parcelRequire.register;
parcelRegister("5KLgR", function(module, exports) {
$parcel$export(module.exports, "ErrorBoundary", () => $2383912d574024e4$export$e926676385687eaf);

var $bSJIT = parcelRequire("bSJIT");

var $9Rfip = parcelRequire("9Rfip");

var $8aT4G = parcelRequire("8aT4G");

var $buKRr = parcelRequire("buKRr");

var $429NB = parcelRequire("429NB");

var $9KQKC = parcelRequire("9KQKC");
function $2383912d574024e4$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $2383912d574024e4$var$EXCLUDED_ERROR_MESSAGES = [
    "Failed to execute 'removeChild' on 'Node': The node to be removed is not a child of this node."
];
class $2383912d574024e4$export$e926676385687eaf extends (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).Component {
    constructor(props){
        super(props);
        this.state = {
            hasError: false,
            errorInfo: null,
            error: null
        };
    }
    componentDidCatch(error, errorInfo) {
        this.setState({
            hasError: true,
            error: error,
            errorInfo: errorInfo.componentStack
        });
        const isExcludedError = error instanceof Error && $2383912d574024e4$var$EXCLUDED_ERROR_MESSAGES.some((message)=>error.message === message);
        this.props.errorUtils.reportError(error, {
            actionSubject: (0, $429NB.ActionSubject).PROFORMA_UI,
            id: isExcludedError ? 'excludedErrors' : 'errorBoundary',
            errorInfo: errorInfo
        });
    }
    render() {
        if (this.state.hasError) {
            // Render error UI here
            const { renderError: renderError } = this.props;
            return renderError ? renderError({
                error: this.state.error
            }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement($2383912d574024e4$var$ErrorPage, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement($2383912d574024e4$var$ErrorPageSection, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $buKRr.default), {
                appearance: "error",
                title: "Something went wrong"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $8aT4G.Text), {
                as: "p"
            }, "Refresh the page and try again. ", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement("br", null), "If the error persists,", ' ', /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $9Rfip.default), {
                href: "https://support.thinktilt.com",
                target: "_blank",
                rel: "noopener noreferrer"
            }, "contact support"), "."))));
        }
        return this.props.children;
    }
}
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $2383912d574024e4$var$ErrorPage = /*#__PURE__*/ (0, $9KQKC.default)("div", {
    target: "e1lfupdm1"
})({
    name: "zigog8",
    styles: "display:flex;flex-direction:column;align-items:center"
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/design-system/no-empty-styled-expression -- Ignored via go/DSP-18766
const $2383912d574024e4$var$ErrorPageSection = /*#__PURE__*/ (0, $9KQKC.default)("div", {
    target: "e1lfupdm0"
})({
    name: "0",
    styles: ""
});

});

parcelRegister("lCetE", function(module, exports) {
$parcel$export(module.exports, "UtilsProvider", () => $28f4f99ef1fcc522$export$df5be093c1f55d13);

var $bSJIT = parcelRequire("bSJIT");

var $fyqAM = parcelRequire("fyqAM");
const $28f4f99ef1fcc522$export$df5be093c1f55d13 = ({ utils: utils, children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $fyqAM.PfErrorUtilsProvider), {
        errorUtils: utils.errorUtils
    }, children);

});
parcelRegister("fyqAM", function(module, exports) {
$parcel$export(module.exports, "PfErrorUtilsProvider", () => $e38cf26400a6d308$export$b71d28c58577f663);
$parcel$export(module.exports, "usePfErrorUtils", () => $e38cf26400a6d308$export$19d62bf1891c25ff);

var $bSJIT = parcelRequire("bSJIT");

var $hXEPo = parcelRequire("hXEPo");
const $e38cf26400a6d308$var$PfErrorUtilsContext = /*#__PURE__*/ (0, $bSJIT.createContext)(undefined);
const $e38cf26400a6d308$export$b71d28c58577f663 = ({ errorUtils: errorUtils, children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement($e38cf26400a6d308$var$PfErrorUtilsContext.Provider, {
        value: errorUtils
    }, children);
function $e38cf26400a6d308$export$19d62bf1891c25ff() {
    const errorUtils = (0, $bSJIT.useContext)($e38cf26400a6d308$var$PfErrorUtilsContext);
    if (errorUtils === undefined) throw new Error(`usePfErrorUtils() must be used within a PfErrorUtilsProvider. ${(0, $hXEPo.errorMessageDuplicateCommonCore)}`);
    return errorUtils;
}

});
parcelRegister("hXEPo", function(module, exports) {
$parcel$export(module.exports, "errorMessageDuplicateCommonCore", () => $267bcd74e34e6533$export$202e68bc03a230f);
const $267bcd74e34e6533$export$202e68bc03a230f = "Please check that the yarn.lock file contains only 1 version of proforma-common-core. You should bump all Proforma packages to their latest version";

});



parcelRegister("8dotP", function(module, exports) {
$parcel$export(module.exports, "Environment", () => $12815d297f3b0fc9$export$7dc6752a22ab011a);
var $12815d297f3b0fc9$export$7dc6752a22ab011a = /*#__PURE__*/ function(Environment) {
    Environment["PRODUCTION"] = "prod";
    Environment["STAGING"] = "staging";
    Environment["DEVELOPMENT"] = "dev";
    Environment["LOCAL"] = "local";
    return Environment;
}({});

});

parcelRegister("qIDsl", function(module, exports) {
$parcel$export(module.exports, "createErrorUtils", () => $b1de562336445abe$export$7a2f0d878b08650d);

var $gkcxo = parcelRequire("gkcxo");

var $e59kp = parcelRequire("e59kp");

var $6LVpS = parcelRequire("6LVpS");
function $b1de562336445abe$export$7a2f0d878b08650d(errorUtilsModuleName, environment, createAnalyticsEvent, showFlag = ()=>()=>{}) {
    return new (0, $6LVpS.LiveErrorUtils)(errorUtilsModuleName, showFlag, createAnalyticsEvent, environment);
}
function $b1de562336445abe$export$b6881d4b4863cacc(settings, errorUtilsModuleName, showFlag, createAnalyticsEvent, locale) {
    const errorUtils = new (0, $6LVpS.LiveErrorUtils)(errorUtilsModuleName, showFlag, createAnalyticsEvent, settings.environment);
    (0, $e59kp.setNoticeLocale)(locale);
    const apiUtil = new (0, $gkcxo.ApiUtil)(settings.urls.jira, settings.urls.api, errorUtils, createAnalyticsEvent);
    return {
        apiUtil: apiUtil,
        errorUtils: errorUtils
    };
}
function $b1de562336445abe$export$e4e37e88de17afb6(jiraUrl, apiUrl, environment, errorUtilsModuleName, showFlag, createAnalyticsEvent, locale) {
    const errorUtils = new (0, $6LVpS.LiveErrorUtils)(errorUtilsModuleName, showFlag, createAnalyticsEvent, environment);
    (0, $e59kp.setNoticeLocale)(locale);
    const apiUtil = new (0, $gkcxo.ApiUtil)(jiraUrl, apiUrl, errorUtils, createAnalyticsEvent);
    return {
        apiUtil: apiUtil,
        errorUtils: errorUtils
    };
}

});
parcelRegister("gkcxo", function(module, exports) {
$parcel$export(module.exports, "ApiUtil", () => $a01f212dd3012b0b$export$baa861b25a2283a4);

var $ezwN8 = parcelRequire("ezwN8");

var $429NB = parcelRequire("429NB");

var $5juzF = parcelRequire("5juzF");

var $iSMR0 = parcelRequire("iSMR0");
var $a01f212dd3012b0b$export$9126c50ecfe2a46d = /*#__PURE__*/ function(AcceptedResponseType) {
    AcceptedResponseType["Json"] = "json";
    AcceptedResponseType["Blob"] = "blob";
    return AcceptedResponseType;
}({});
class $a01f212dd3012b0b$export$baa861b25a2283a4 {
    constructor(jiraUrl, proformaUrl, errorUtils, createAnalyticsEvent){
        this.jiraUrl = jiraUrl;
        this.proformaUrl = proformaUrl;
        this.errorUtils = errorUtils;
        this.createAnalyticsEvent = createAnalyticsEvent;
    }
    get(path, requestName, responseType = "json") {
        return this.fetchApi(true, 'GET', path, responseType, requestName);
    }
    jiraGet(path, requestName, responseType = "json") {
        return this.fetchApi(false, 'GET', path, responseType, requestName);
    }
    put(path, body, requestName, responseType = "json") {
        return this.fetchApi(true, 'PUT', path, responseType, requestName, body);
    }
    jiraPut(path, body, requestName, responseType = "json") {
        return this.fetchApi(false, 'PUT', path, responseType, requestName, body);
    }
    post(path, body, requestName, responseType = "json") {
        return this.fetchApi(true, 'POST', path, responseType, requestName, body);
    }
    patch(path, body, requestName, responseType = "json") {
        return this.fetchApi(true, 'PATCH', path, responseType, requestName, body);
    }
    jiraPost(path, body, requestName, responseType = "json") {
        return this.fetchApi(false, 'POST', path, responseType, requestName, body);
    }
    delete(path, body, requestName, responseType = 'none') {
        return this.fetchApi(true, 'DELETE', path, responseType, requestName, body);
    }
    /** Converts the `relativePath` into an absolute ProForma API URI. */ createApiUrl(relativePath) {
        return this.proformaUrl + (relativePath.charAt(0) === '/' ? '' : '/') + relativePath;
    }
    /** Converts the `relativePath` into an absolute Jira URI. */ createJiraUrl(relativePath) {
        return this.jiraUrl + (relativePath.charAt(0) === '/' ? '' : '/') + relativePath;
    }
    getAnalyticsSource() {
        try {
            var _analyticsData$payloa;
            const analyticsEvent = this.createAnalyticsEvent({});
            const analyticsData = (0, $ezwN8.extractAWCDataFromEvent)(analyticsEvent);
            return (analyticsData === null || analyticsData === void 0 || (_analyticsData$payloa = analyticsData.payload) === null || _analyticsData$payloa === void 0 ? void 0 : _analyticsData$payloa.source) ?? 'unknown';
        /* eslint-disable no-unused-vars */ } catch (e) {
            return 'unknown';
        }
    }
    fetchApi(proForma, method, path, responseType, requestName, body) {
        const analyticsSource = this.getAnalyticsSource();
        return fetch(proForma ? this.createApiUrl(path) : this.createJiraUrl(path), {
            method: method,
            credentials: 'same-origin',
            headers: {
                'Content-Type': 'application/json',
                'X-Experimental-Experience': analyticsSource,
                ...responseType === "json" ? {
                    Accept: 'application/json'
                } : {}
            },
            ...body && {
                body: JSON.stringify(body)
            }
        }).catch((error)=>{
            const message = `No response from API: ${error.message || ''}`;
            const apiError = $a01f212dd3012b0b$var$toApiError(0, {
                error: message
            }, true, requestName);
            this.errorUtils.reportError(error, {
                actionSubject: (0, $429NB.ActionSubject).PROFORMA_API,
                id: 'fetchApi',
                attributes: {
                    path: path,
                    method: method,
                    responseType: responseType,
                    requestName: requestName,
                    apiError: JSON.stringify(apiError),
                    isClientFetchError: true
                }
            });
            return Promise.reject(apiError);
        }).then((response)=>{
            let errorObj = new Error(response.statusText);
            if (!response.ok) {
                const traceId = response.headers.get('x-trace-id') ?? response.headers.get('atl-traceid') ?? undefined;
                let apiErrorPromise;
                try {
                    // Try to parse response error details
                    const responseJsonApiError = responseType !== 'json' ? undefined : response.json().then((responseJson)=>$a01f212dd3012b0b$var$toApiError(response.status, responseJson, false, requestName, traceId)).catch((error)=>{
                        const message = `Failed to parse error response as JSON from API: ${error.message || ''}`;
                        errorObj = error;
                        return $a01f212dd3012b0b$var$toApiError(response.status, {
                            error: message
                        }, false, requestName, traceId);
                    });
                    if (response.status === 401) this.errorUtils.notifyUser((0, $5juzF.NoticeType).ErrorApiUnauthorised);
                    if (response.status === 403) this.errorUtils.notifyUser((0, $5juzF.NoticeType).ErrorApiMissingPermissions);
                    if (responseJsonApiError !== undefined) apiErrorPromise = responseJsonApiError.then((apiError)=>Promise.reject(apiError));
                    else // Create error object with error response body
                    apiErrorPromise = Promise.reject($a01f212dd3012b0b$var$toApiError(response.status, {
                        error: response.body || ''
                    }, false, requestName, traceId));
                } catch (error) {
                    const message = `Unexpected response from API: ${response.body || ''}`;
                    errorObj = error;
                    apiErrorPromise = Promise.reject($a01f212dd3012b0b$var$toApiError(response.status, {
                        error: message
                    }, false, requestName, traceId));
                }
                apiErrorPromise.catch((apiError)=>{
                    this.errorUtils.reportError(errorObj, {
                        actionSubject: (0, $429NB.ActionSubject).PROFORMA_API,
                        id: 'fetchApi',
                        attributes: {
                            status: response.status,
                            statusGroup: `${Math.floor(response.status / 100)}xx`,
                            traceId: traceId,
                            path: path,
                            method: method,
                            responseType: responseType,
                            requestName: requestName,
                            apiError: JSON.stringify(apiError),
                            isClientFetchError: false
                        }
                    });
                });
                return apiErrorPromise;
            }
            if (response.status === 204) return '';
            switch(responseType){
                case 'json':
                    return response.json();
                case 'blob':
                    return response.blob();
                case 'text':
                    return response.text();
                case 'none':
                    return '';
                default:
                    return response;
            }
        });
    }
}
function $a01f212dd3012b0b$var$toApiError(status, responseJson, isClientFetchError, requestName, traceId) {
    if (Object.keys(responseJson).length === 0) return (0, $iSMR0.constructApiError)(`Unexpected API reply (HTTP/${status})`, status, responseJson, requestName);
    const error = responseJson['error'] || `Unexpected API reply (HTTP/${status})`;
    // oxlint-disable-next-line prefer-destructuring
    const context = responseJson['context'];
    // oxlint-disable-next-line prefer-destructuring
    const contextId = responseJson['contextId'];
    // oxlint-disable-next-line prefer-destructuring
    const details = responseJson['details'];
    return (0, $iSMR0.constructApiError)(error, status, responseJson, requestName, context, contextId, details, isClientFetchError, traceId);
}

});
parcelRegister("5juzF", function(module, exports) {
$parcel$export(module.exports, "NoticeType", () => $78bcdbf78b61ab04$export$3b5003ffe8119af2);
$parcel$export(module.exports, "Notices", () => $78bcdbf78b61ab04$export$ba15f0a357d713fd);

var $cDmQj = parcelRequire("cDmQj");

var $5Pv4s = parcelRequire("5Pv4s");
var $78bcdbf78b61ab04$export$3b5003ffe8119af2 = /*#__PURE__*/ function(NoticeType) {
    NoticeType["ConfirmDeleteForm"] = "ConfirmDeleteForm";
    NoticeType["ConfirmChangeFormToInternal"] = "ConfirmChangeFormToInternal";
    NoticeType["ConfirmChangeFormToExternal"] = "ConfirmChangeFormToExternal";
    NoticeType["ConfirmCancelEdit"] = "ConfirmCancelEdit";
    NoticeType["ConfirmSubmitForm"] = "ConfirmSubmitForm";
    NoticeType["ConfirmSubmitFormLock"] = "ConfirmSubmitFormLock";
    NoticeType["ConfirmReopenForm"] = "ConfirmReopenForm";
    NoticeType["ErrorApiUnauthorised"] = "ErrorApiUnauthorised";
    NoticeType["ErrorApiMissingPermissions"] = "ErrorApiMissingPermissions";
    NoticeType["ErrorApiAddConnectionFailed"] = "ErrorApiAddConnectionFailed";
    NoticeType["ErrorApiUpdateConnectionFailed"] = "ErrorApiUpdateConnectionFailed";
    NoticeType["ErrorApiSubmitFormFailed"] = "ErrorApiSubmitFormFailed";
    NoticeType["ErrorApiSaveFormFailed"] = "ErrorApiSaveFormFailed";
    NoticeType["ErrorApiSaveFormFailedOnConflict"] = "ErrorApiSaveFormFailedOnConflict";
    NoticeType["ErrorApiSaveFormInvalidAnswersFailed"] = "ErrorApiSaveFormInvalidAnswersFailed";
    NoticeType["ErrorApiSaveTemplateFormFailed"] = "ErrorApiSaveTemplateFormFailed";
    NoticeType["ErrorApiLoadTemplateFormFailed"] = "ErrorApiLoadTemplateFormFailed";
    NoticeType["ErrorApiLoadJiraFieldsFailed"] = "ErrorApiLoadJiraFieldsFailed";
    NoticeType["ErrorApiLoadDataConnectionsFailed"] = "ErrorApiLoadDataConnectionsFailed";
    NoticeType["ErrorApiLoadSettingsRefDataFailed"] = "ErrorApiLoadSettingsRefDataFailed";
    return NoticeType;
}({});
const $78bcdbf78b61ab04$export$ba15f0a357d713fd = {
    ["ConfirmDeleteForm"]: {
        title: (0, $5Pv4s.IntlNoticeMessages)[(0, $5Pv4s.NoticeMessage).DeleteFormTitle],
        message: (0, $5Pv4s.IntlNoticeMessages)[(0, $5Pv4s.NoticeMessage).DeleteFormMsg],
        confirmText: (0, $5Pv4s.IntlNoticeMessages)[(0, $5Pv4s.NoticeMessage).Delete],
        isWarningNotice: true
    },
    ["ConfirmChangeFormToInternal"]: {
        title: (0, $5Pv4s.IntlNoticeMessages)[(0, $5Pv4s.NoticeMessage).ChangeFormToInternalHeader],
        message: (0, $5Pv4s.IntlNoticeMessages)[(0, $5Pv4s.NoticeMessage).ChangeFormToInternalMsg],
        confirmText: (0, $5Pv4s.IntlNoticeMessages)[(0, $5Pv4s.NoticeMessage).MakeInternal]
    },
    ["ConfirmChangeFormToExternal"]: {
        title: (0, $5Pv4s.IntlNoticeMessages)[(0, $5Pv4s.NoticeMessage).ChangeFormToExternalHeader],
        message: (0, $5Pv4s.IntlNoticeMessages)[(0, $5Pv4s.NoticeMessage).ChangeFormToExternalMsg],
        confirmText: (0, $5Pv4s.IntlNoticeMessages)[(0, $5Pv4s.NoticeMessage).MakeExternal]
    },
    ["ConfirmCancelEdit"]: {
        title: (0, $5Pv4s.IntlNoticeMessages)[(0, $5Pv4s.NoticeMessage).CancelEditFormTitle],
        message: (0, $5Pv4s.IntlNoticeMessages)[(0, $5Pv4s.NoticeMessage).CancelEditFormMsg],
        confirmText: (0, $5Pv4s.IntlNoticeMessages)[(0, $5Pv4s.NoticeMessage).Confirm]
    },
    ["ConfirmSubmitForm"]: {
        title: (0, $5Pv4s.IntlNoticeMessages)[(0, $5Pv4s.NoticeMessage).SubmitFormTitle],
        message: (0, $5Pv4s.IntlNoticeMessages)[(0, $5Pv4s.NoticeMessage).SubmitFormMsg],
        confirmText: (0, $5Pv4s.IntlNoticeMessages)[(0, $5Pv4s.NoticeMessage).Submit]
    },
    ["ConfirmSubmitFormLock"]: {
        title: (0, $5Pv4s.IntlNoticeMessages)[(0, $5Pv4s.NoticeMessage).SubmitFormTitle],
        message: (0, $5Pv4s.IntlNoticeMessages)[(0, $5Pv4s.NoticeMessage).SubmitFormLockMsg],
        confirmText: (0, $5Pv4s.IntlNoticeMessages)[(0, $5Pv4s.NoticeMessage).Submit]
    },
    ["ConfirmReopenForm"]: {
        title: (0, $5Pv4s.IntlNoticeMessages)[(0, $5Pv4s.NoticeMessage).ReopenFormTitle],
        message: (0, $5Pv4s.IntlNoticeMessages)[(0, $5Pv4s.NoticeMessage).ReopenFormMsg],
        confirmText: (0, $5Pv4s.IntlNoticeMessages)[(0, $5Pv4s.NoticeMessage).Reopen]
    },
    ["ErrorApiUnauthorised"]: {
        title: (0, $cDmQj.IntlApiErrorMessages)[(0, $cDmQj.ApiErrorMessage).UnauthorisedTitle],
        message: (0, $cDmQj.IntlApiErrorMessages)[(0, $cDmQj.ApiErrorMessage).UnauthorisedMsg],
        confirmText: (0, $5Pv4s.IntlNoticeMessages)[(0, $5Pv4s.NoticeMessage).Close],
        isErrorNotice: true
    },
    ["ErrorApiMissingPermissions"]: {
        title: (0, $cDmQj.IntlApiErrorMessages)[(0, $cDmQj.ApiErrorMessage).MissingPermissionsTitle],
        message: (0, $cDmQj.IntlApiErrorMessages)[(0, $cDmQj.ApiErrorMessage).MissingPermissionsMsg],
        confirmText: (0, $5Pv4s.IntlNoticeMessages)[(0, $5Pv4s.NoticeMessage).Close],
        isErrorNotice: true
    },
    ["ErrorApiAddConnectionFailed"]: {
        title: (0, $cDmQj.IntlApiErrorMessages)[(0, $cDmQj.ApiErrorMessage).AddConnectionFailedTitle],
        message: (0, $cDmQj.IntlApiErrorMessages)[(0, $cDmQj.ApiErrorMessage).AddConnectionFailedMsg],
        confirmText: (0, $5Pv4s.IntlNoticeMessages)[(0, $5Pv4s.NoticeMessage).Close],
        isErrorNotice: true
    },
    ["ErrorApiUpdateConnectionFailed"]: {
        title: (0, $cDmQj.IntlApiErrorMessages)[(0, $cDmQj.ApiErrorMessage).UpdateConnectionFailedTitle],
        message: (0, $cDmQj.IntlApiErrorMessages)[(0, $cDmQj.ApiErrorMessage).UpdateConnectionFailedMsg],
        confirmText: (0, $5Pv4s.IntlNoticeMessages)[(0, $5Pv4s.NoticeMessage).Close],
        isErrorNotice: true
    },
    ["ErrorApiSubmitFormFailed"]: {
        title: (0, $cDmQj.IntlApiErrorMessages)[(0, $cDmQj.ApiErrorMessage).SubmitFormFailedTitle],
        message: (0, $cDmQj.IntlApiErrorMessages)[(0, $cDmQj.ApiErrorMessage).SubmitFormFailedMsg],
        confirmText: (0, $5Pv4s.IntlNoticeMessages)[(0, $5Pv4s.NoticeMessage).Close],
        isErrorNotice: true
    },
    ["ErrorApiSaveFormFailed"]: {
        title: (0, $cDmQj.IntlApiErrorMessages)[(0, $cDmQj.ApiErrorMessage).SaveFormFailedTitle],
        message: (0, $cDmQj.IntlApiErrorMessages)[(0, $cDmQj.ApiErrorMessage).SaveFormFailedMsg],
        confirmText: (0, $5Pv4s.IntlNoticeMessages)[(0, $5Pv4s.NoticeMessage).Close],
        isErrorNotice: true
    },
    ["ErrorApiSaveFormInvalidAnswersFailed"]: {
        title: (0, $cDmQj.IntlApiErrorMessages)[(0, $cDmQj.ApiErrorMessage).SaveFormFailedTitle],
        message: (0, $cDmQj.IntlApiErrorMessages)[(0, $cDmQj.ApiErrorMessage).SaveFormInvalidAnswersMsg],
        confirmText: (0, $5Pv4s.IntlNoticeMessages)[(0, $5Pv4s.NoticeMessage).Close],
        isErrorNotice: true
    },
    ["ErrorApiSaveFormFailedOnConflict"]: {
        title: (0, $cDmQj.IntlApiErrorMessages)[(0, $cDmQj.ApiErrorMessage).SaveFormFailedTitle],
        message: (0, $cDmQj.IntlApiErrorMessages)[(0, $cDmQj.ApiErrorMessage).SaveFormFailedOnConflictMsg],
        confirmText: (0, $5Pv4s.IntlNoticeMessages)[(0, $5Pv4s.NoticeMessage).Close],
        isErrorNotice: true
    },
    ["ErrorApiSaveTemplateFormFailed"]: {
        title: (0, $cDmQj.IntlApiErrorMessages)[(0, $cDmQj.ApiErrorMessage).SaveTemplateFormFailedTitle],
        message: (0, $cDmQj.IntlApiErrorMessages)[(0, $cDmQj.ApiErrorMessage).SaveTemplateFormFailedMsg],
        confirmText: (0, $5Pv4s.IntlNoticeMessages)[(0, $5Pv4s.NoticeMessage).Close],
        isErrorNotice: true
    },
    ["ErrorApiLoadTemplateFormFailed"]: {
        title: (0, $cDmQj.IntlApiErrorMessages)[(0, $cDmQj.ApiErrorMessage).LoadTemplateFormFailedTitle],
        message: (0, $cDmQj.IntlApiErrorMessages)[(0, $cDmQj.ApiErrorMessage).LoadTemplateFormFailedMsg],
        confirmText: (0, $5Pv4s.IntlNoticeMessages)[(0, $5Pv4s.NoticeMessage).Close],
        isErrorNotice: true
    },
    ["ErrorApiLoadJiraFieldsFailed"]: {
        title: (0, $cDmQj.IntlApiErrorMessages)[(0, $cDmQj.ApiErrorMessage).LoadJiraFieldsFailedTitle],
        message: (0, $cDmQj.IntlApiErrorMessages)[(0, $cDmQj.ApiErrorMessage).LoadJiraFieldsFailedMsg],
        confirmText: (0, $5Pv4s.IntlNoticeMessages)[(0, $5Pv4s.NoticeMessage).Close],
        isErrorNotice: true
    },
    ["ErrorApiLoadDataConnectionsFailed"]: {
        title: (0, $cDmQj.IntlApiErrorMessages)[(0, $cDmQj.ApiErrorMessage).LoadDataConnectionsFailedTitle],
        message: (0, $cDmQj.IntlApiErrorMessages)[(0, $cDmQj.ApiErrorMessage).LoadDataConnectionsFailedMsg],
        confirmText: (0, $5Pv4s.IntlNoticeMessages)[(0, $5Pv4s.NoticeMessage).Close],
        isErrorNotice: true
    },
    ["ErrorApiLoadSettingsRefDataFailed"]: {
        title: (0, $cDmQj.IntlApiErrorMessages)[(0, $cDmQj.ApiErrorMessage).LoadSettingsRefDataFailedTitle],
        message: (0, $cDmQj.IntlApiErrorMessages)[(0, $cDmQj.ApiErrorMessage).LoadSettingsRefDataFailedMsg],
        confirmText: (0, $5Pv4s.IntlNoticeMessages)[(0, $5Pv4s.NoticeMessage).Close],
        isErrorNotice: true
    }
};

});
parcelRegister("cDmQj", function(module, exports) {
$parcel$export(module.exports, "ApiErrorMessage", () => $46fbfe0a9a03c6ec$export$231e36d3eb058aab);
$parcel$export(module.exports, "IntlApiErrorMessages", () => $46fbfe0a9a03c6ec$export$4a210a14fc5cbd69);

var $f0Pt4 = parcelRequire("f0Pt4");
var $46fbfe0a9a03c6ec$export$231e36d3eb058aab = /*#__PURE__*/ function(ApiErrorMessage) {
    ApiErrorMessage["UnauthorisedTitle"] = "UnauthorisedTitle";
    ApiErrorMessage["UnauthorisedMsg"] = "UnauthorisedMsg";
    ApiErrorMessage["MissingPermissionsTitle"] = "MissingPermissionsTitle";
    ApiErrorMessage["MissingPermissionsMsg"] = "MissingPermissionsMsg";
    ApiErrorMessage["AddConnectionFailedTitle"] = "AddConnectionFailedTitle";
    ApiErrorMessage["AddConnectionFailedMsg"] = "AddConnectionFailedMsg";
    ApiErrorMessage["UpdateConnectionFailedTitle"] = "UpdateConnectionFailedTitle";
    ApiErrorMessage["UpdateConnectionFailedMsg"] = "UpdateConnectionFailedMsg";
    ApiErrorMessage["SubmitFormFailedTitle"] = "SubmitFormFailedTitle";
    ApiErrorMessage["SubmitFormFailedMsg"] = "SubmitFormFailedMsg";
    ApiErrorMessage["SaveFormFailedTitle"] = "SaveFormFailedTitle";
    ApiErrorMessage["SaveFormFailedMsg"] = "SaveFormFailedMsg";
    ApiErrorMessage["SaveFormInvalidAnswersMsg"] = "SaveFormInvalidAnswersMsg";
    ApiErrorMessage["SaveFormFailedOnConflictMsg"] = "SaveFormFailedOnConflictMsg";
    ApiErrorMessage["SaveTemplateFormFailedTitle"] = "SaveTemplateFormFailedTitle";
    ApiErrorMessage["SaveTemplateFormFailedMsg"] = "SaveTemplateFormFailedMsg";
    ApiErrorMessage["LoadTemplateFormFailedTitle"] = "LoadTemplateFormFailedTitle";
    ApiErrorMessage["LoadTemplateFormFailedMsg"] = "LoadTemplateFormFailedMsg";
    ApiErrorMessage["LoadJiraFieldsFailedTitle"] = "LoadJiraFieldsFailedTitle";
    ApiErrorMessage["LoadJiraFieldsFailedMsg"] = "LoadJiraFieldsFailedMsg";
    ApiErrorMessage["LoadDataConnectionsFailedTitle"] = "LoadDataConnectionsFailedTitle";
    ApiErrorMessage["LoadDataConnectionsFailedMsg"] = "LoadDataConnectionsFailedMsg";
    ApiErrorMessage["LoadSettingsRefDataFailedTitle"] = "LoadSettingsRefDataFailedTitle";
    ApiErrorMessage["LoadSettingsRefDataFailedMsg"] = "LoadSettingsRefDataFailedMsg";
    return ApiErrorMessage;
}({});
const $46fbfe0a9a03c6ec$export$4a210a14fc5cbd69 = (0, $f0Pt4.defineMessages)({
    ["UnauthorisedTitle"]: {
        id: 'ui-notices.apiError.title.UnauthorisedTitle',
        defaultMessage: 'Error: User Unauthorised',
        description: 'Title of the error notice shown when the user is unauthorized to perform an action'
    },
    ["UnauthorisedMsg"]: {
        id: 'ui-notices.apiError.msg.UnauthorisedMsg',
        defaultMessage: 'Try refreshing your page or logging into Jira again.',
        description: 'Error message body instructing the user to refresh or re-login when unauthorized'
    },
    ["MissingPermissionsTitle"]: {
        id: 'ui-notices.apiError.title.MissingPermissionsTitle',
        defaultMessage: 'Error: User is not allowed this action',
        description: 'Title of the error notice shown when the user lacks permissions for an action'
    },
    ["MissingPermissionsMsg"]: {
        id: 'ui-notices.apiError.msg.MissingPermissionsMsg',
        defaultMessage: 'You do not have the necessary permissions to perform this action. Please contact your Jira Administrator.',
        description: 'Error message body shown when the user lacks required permissions to perform an action'
    },
    ["AddConnectionFailedTitle"]: {
        id: 'ui-notices.apiError.title.AddConnectionFailedTitle',
        defaultMessage: 'Error: Adding data connection failed',
        description: 'Title of the error notice shown when adding a data connection fails'
    },
    ["AddConnectionFailedMsg"]: {
        id: 'ui-notices.apiError.msg.AddConnectionFailedMsg',
        defaultMessage: 'A server error occurred while trying to add the data connection.',
        description: 'Error message body shown when a server error prevents a data connection from being added'
    },
    ["UpdateConnectionFailedTitle"]: {
        id: 'ui-notices.apiError.title.UpdateConnectionFailedTitle',
        defaultMessage: 'Error: Updating data connection failed',
        description: 'Title of the error notice shown when updating a data connection fails'
    },
    ["UpdateConnectionFailedMsg"]: {
        id: 'ui-notices.apiError.msg.UpdateConnectionFailedMsg',
        defaultMessage: 'A server error occurred while trying to update the data connection.',
        description: 'Error message body shown when a server error prevents a data connection from being updated'
    },
    ["SubmitFormFailedTitle"]: {
        id: 'ui-notices.apiError.title.SubmitFormFailedTitle',
        defaultMessage: 'Error: Submitting form failed',
        description: 'Title of the error notice shown when form submission fails due to a server error'
    },
    ["SubmitFormFailedMsg"]: {
        id: 'ui-notices.apiError.msg.SubmitFormFailedMsg',
        defaultMessage: 'A server error occurred while trying to submit the form.',
        description: 'Error message body shown when a server error prevents the form from being submitted'
    },
    ["SaveFormFailedTitle"]: {
        id: 'ui-notices.apiError.title.SaveFormFailedTitle',
        defaultMessage: "We couldn\u2019t save your changes",
        description: 'The title on the error flag informing customers that their form failed to save.'
    },
    ["SaveFormFailedMsg"]: {
        id: 'ui-notices.apiError.msg.SaveFormFailedMsg',
        defaultMessage: 'A server error occurred while trying to save the form.',
        description: 'Error message body shown when a server error prevents the form from being saved'
    },
    ["SaveFormInvalidAnswersMsg"]: {
        id: 'ui-notices.apiError.msg.SaveFormInvalidAnswersMsg',
        defaultMessage: 'Resolve any invalid answers and check all required fields are complete.',
        description: 'The error message on the error flag informing customers that their form failed to save due to invalid answers.'
    },
    ["SaveFormFailedOnConflictMsg"]: {
        id: 'ui-notices.apiError.msg.SaveFormFailedOnConflictMsg',
        defaultMessage: 'The settings for this form have been changed. If you believe this was an error, leave a comment on the request.',
        description: "The error message on error flag informing customers about what happened and what to do when saving form answers request was rejected because the form state doesn't allow the customer to do so."
    },
    ["SaveTemplateFormFailedTitle"]: {
        id: 'ui-notices.apiError.title.SaveTemplateFormFailedTitle',
        defaultMessage: 'Error: Saving template form failed',
        description: 'Title of the error notice shown when saving a template form fails'
    },
    ["SaveTemplateFormFailedMsg"]: {
        id: 'ui-notices.apiError.msg.SaveTemplateFormFailedMsg',
        defaultMessage: 'A server error occurred while trying to save the template form.',
        description: 'Error message body shown when a server error prevents the template form from being saved'
    },
    ["LoadTemplateFormFailedTitle"]: {
        id: 'ui-notices.apiError.title.LoadTemplateFormFailedTitle',
        defaultMessage: "We couldn\u2019t load your form",
        description: 'Title of the error notice shown when loading a template form fails'
    },
    ["LoadTemplateFormFailedMsg"]: {
        id: 'ui-notices.apiError.msg.LoadTemplateFormFailedMsg',
        defaultMessage: 'Refresh the page to try again',
        description: 'Error message body shown when loading the template form fails, instructing the user to refresh'
    },
    ["LoadJiraFieldsFailedTitle"]: {
        id: 'ui-notices.apiError.title.LoadJiraFieldsFailedTitle',
        defaultMessage: 'Error: Loading Jira fields failed',
        description: 'Title of the error notice shown when Jira fields fail to load on the template form'
    },
    ["LoadJiraFieldsFailedMsg"]: {
        id: 'ui-notices.apiError.msg.LoadJiraFieldsFailedMsg',
        defaultMessage: 'A server error occurred while trying to load Jira fields on the template form.',
        description: 'Error message body shown when a server error prevents Jira fields from loading on the template form'
    },
    ["LoadDataConnectionsFailedTitle"]: {
        id: 'ui-notices.apiError.title.LoadDataConnectionsFailedTitle',
        defaultMessage: 'Error: Loading data connections failed.',
        description: 'Title of the error notice shown when data connections fail to load on the template form'
    },
    ["LoadDataConnectionsFailedMsg"]: {
        id: 'ui-notices.apiError.msg.LoadDataConnectionsFailedMsg',
        defaultMessage: 'A server error occurred while trying to load data connections on the template form.',
        description: 'Error message body shown when a server error prevents data connections from loading on the template form'
    },
    ["LoadSettingsRefDataFailedTitle"]: {
        id: 'ui-notices.apiError.title.LoadSettingsRefDataFailedTitle',
        defaultMessage: 'Error: Loading form settings reference data failed.',
        description: 'Title of the error notice shown when form settings reference data fails to load'
    },
    ["LoadSettingsRefDataFailedMsg"]: {
        id: 'ui-notices.apiError.msg.LoadSettingsRefDataFailedMsg',
        defaultMessage: "A server error occurred while trying to load the reference for the template form's settings.",
        description: 'Error message body shown when a server error prevents form settings reference data from loading'
    }
});

});

parcelRegister("5Pv4s", function(module, exports) {
$parcel$export(module.exports, "NoticeMessage", () => $e981052897b9f0e2$export$cd61f3d27ce0e442);
$parcel$export(module.exports, "IntlNoticeMessages", () => $e981052897b9f0e2$export$5f3ce93e2cd01692);

var $f0Pt4 = parcelRequire("f0Pt4");
var $e981052897b9f0e2$export$cd61f3d27ce0e442 = /*#__PURE__*/ function(NoticeMessage) {
    NoticeMessage["Delete"] = "Delete";
    NoticeMessage["Discard"] = "Discard";
    NoticeMessage["Change"] = "Change";
    NoticeMessage["Confirm"] = "Confirm";
    NoticeMessage["Submit"] = "Submit";
    NoticeMessage["Reopen"] = "Reopen";
    NoticeMessage["Close"] = "Close";
    NoticeMessage["Cancel"] = "Cancel";
    NoticeMessage["UpgradeNow"] = "UpgradeNow";
    NoticeMessage["MakeInternal"] = "MakeInternal";
    NoticeMessage["MakeExternal"] = "MakeExternal";
    NoticeMessage["DeleteFormTitle"] = "DeleteFormTitle";
    NoticeMessage["DeleteFormMsg"] = "DeleteFormMsg";
    NoticeMessage["ChangeFormAvailabilityTitle"] = "ChangeFormAvailabilityTitle";
    NoticeMessage["ChangeFormToInternalHeader"] = "ChangeFormToInternalHeader";
    NoticeMessage["ChangeFormToInternalMsg"] = "ChangeFormToInternalMsg";
    NoticeMessage["ChangeFormToExternalHeader"] = "ChangeFormToExternalHeader";
    NoticeMessage["ChangeFormToExternalMsg"] = "ChangeFormToExternalMsg";
    NoticeMessage["CancelEditFormTitle"] = "CancelEditFormTitle";
    NoticeMessage["CancelEditFormMsg"] = "CancelEditFormMsg";
    NoticeMessage["SubmitFormTitle"] = "SubmitFormTitle";
    NoticeMessage["SubmitFormMsg"] = "SubmitFormMsg";
    NoticeMessage["SubmitFormLockMsg"] = "SubmitFormLockMsg";
    NoticeMessage["ReopenFormTitle"] = "ReopenFormTitle";
    NoticeMessage["ReopenFormMsg"] = "ReopenFormMsg";
    NoticeMessage["ErrorExplanations1"] = "ErrorExplanations1";
    NoticeMessage["ErrorExplanations2"] = "ErrorExplanations2";
    NoticeMessage["ErrorExplanations3"] = "ErrorExplanations3";
    NoticeMessage["ErrorExplanations4"] = "ErrorExplanations4";
    return NoticeMessage;
}({});
const $e981052897b9f0e2$export$5f3ce93e2cd01692 = (0, $f0Pt4.defineMessages)({
    ["Delete"]: {
        id: 'ui-notices.confirmText.Delete',
        defaultMessage: 'Delete',
        description: 'Confirm button label for the delete action in a notice dialog'
    },
    ["Discard"]: {
        id: 'ui-notices.confirmText.Discard',
        defaultMessage: 'Discard',
        description: 'Confirm button label for the discard action in a notice dialog'
    },
    ["Change"]: {
        id: 'ui-notices.confirmText.Change',
        defaultMessage: 'Change',
        description: 'Confirm button label for the change action in a notice dialog'
    },
    ["Confirm"]: {
        id: 'ui-notices.confirmText.Confirm',
        defaultMessage: 'Confirm',
        description: 'Confirm button label for the confirm action in a notice dialog'
    },
    ["Submit"]: {
        id: 'ui-notices.confirmText.Submit',
        defaultMessage: 'Submit',
        description: 'Confirm button label for the submit action in a notice dialog'
    },
    ["Reopen"]: {
        id: 'ui-notices.confirmText.Reopen',
        defaultMessage: 'Reopen',
        description: 'Confirm button label for the reopen action in a notice dialog'
    },
    ["Close"]: {
        id: 'ui-notices.confirmText.Close',
        defaultMessage: 'Close',
        description: 'Confirm button label for the close action in a notice dialog'
    },
    ["Cancel"]: {
        id: 'ui-notices.confirmText.Cancel',
        defaultMessage: 'Cancel',
        description: 'Confirm button label for the cancel action in a notice dialog'
    },
    ["UpgradeNow"]: {
        id: 'ui-notices.confirmText.UpgradeNow',
        defaultMessage: 'Upgrade Now',
        description: 'Button label prompting the user to upgrade their plan in a notice dialog'
    },
    ["MakeInternal"]: {
        id: 'ui-notices.confirmText.MakeInternal',
        defaultMessage: 'Make internal',
        description: 'Button label to confirm making a form internal and hidden from customers'
    },
    ["MakeExternal"]: {
        id: 'ui-notices.confirmText.MakeExternal',
        defaultMessage: 'Make external',
        description: 'Button label to confirm making a form external and visible to customers'
    },
    ["DeleteFormTitle"]: {
        id: 'ui-notices.title.DeleteFormTitle',
        defaultMessage: 'Confirm Deleting Form',
        description: 'Title of the confirmation dialog shown before the user deletes a form'
    },
    ["DeleteFormMsg"]: {
        id: 'ui-notices.msg.DeleteFormMsg',
        defaultMessage: 'Are you sure you want to delete the "{formName}" form? This cannot be undone.',
        description: 'Confirmation message body asking the user to confirm deletion of the named form'
    },
    ["ChangeFormAvailabilityTitle"]: {
        id: 'ui-notices.title.ChangeFormAvailabilityTitle',
        defaultMessage: 'Confirm Changing Form Availability',
        description: 'Title of the confirmation dialog before changing a form availability setting'
    },
    ["ChangeFormToInternalHeader"]: {
        id: 'ui-notices.title.ChangeFormInternalHeader',
        defaultMessage: 'Make form internal only and hide from customer',
        description: 'Header in the dialog for making a form internal and hidden from customers'
    },
    ["ChangeFormToInternalMsg"]: {
        id: 'ui-notices.msg.ChangeFormInternalMsg',
        defaultMessage: 'Any forms made internal will only be seen by agents and hidden in the portal from customers.',
        description: 'Body text explaining what happens when a form is made internal in the portal'
    },
    ["ChangeFormToExternalHeader"]: {
        id: 'ui-notices.title.ChangeFormToExternalHeader',
        defaultMessage: 'Make form external and show to customer',
        description: 'Header in the dialog for making a form external and visible to customers'
    },
    ["ChangeFormToExternalMsg"]: {
        id: 'ui-notices.msg.ChangeFormToExternalMsg',
        defaultMessage: 'Customers will be able to view this form in the portal and it will no longer be internal only.',
        description: 'Body text explaining what happens when a form is made external in the portal'
    },
    ["CancelEditFormTitle"]: {
        id: 'ui-notices.title.CancelEditFormTitle',
        defaultMessage: 'Confirm Discarding Changes',
        description: 'Title of the confirmation dialog shown before discarding unsaved form edits'
    },
    ["CancelEditFormMsg"]: {
        id: 'ui-notices.msg.CancelEditFormMsg',
        defaultMessage: 'There are changes to answers on the "{formName}" form that will be lost if you choose "Confirm". Are you sure you want to continue?',
        description: 'Warning message body shown when discarding unsaved form edits, with the form name as a placeholder'
    },
    ["SubmitFormTitle"]: {
        id: 'ui-notices.title.SubmitFormTitle',
        defaultMessage: 'Confirm Form Submission',
        description: 'Title of the confirmation dialog shown before the user submits a form'
    },
    ["SubmitFormMsg"]: {
        id: 'ui-notices.msg.SubmitFormMsg',
        defaultMessage: 'Are you sure you want to submit this form ?',
        description: 'Confirmation message body asking the user to confirm they want to submit the form'
    },
    ["SubmitFormLockMsg"]: {
        id: 'ui-notices.msg.SubmitFormLockMsg',
        defaultMessage: 'Are you sure you want to submit this form ? Once submitted no further changes can be made.',
        description: 'Confirmation message body warning the user that submitting the form will lock it from further edits'
    },
    ["ReopenFormTitle"]: {
        id: 'ui-notices.title.ReopenFormTitle',
        defaultMessage: 'Confirm Reopening Form',
        description: 'Title of the confirmation dialog shown before the user reopens a submitted form for editing'
    },
    ["ReopenFormMsg"]: {
        id: 'ui-notices.msg.ReopenFormMsg',
        defaultMessage: 'Are you sure you want to reopen the submitted form for editing?',
        description: 'Confirmation message body asking the user to confirm they want to reopen a submitted form'
    },
    ["ErrorExplanations1"]: {
        id: 'ui-notices.msg.ErrorExplanations1',
        defaultMessage: 'Please refer to our',
        description: 'First segment of the error explanation sentence directing the user to documentation'
    },
    ["ErrorExplanations2"]: {
        id: 'ui-notices.msg.ErrorExplanations2',
        defaultMessage: 'Error Explanations',
        description: 'Link text for the error explanations page, shown as part of an error support message'
    },
    ["ErrorExplanations3"]: {
        id: 'ui-notices.msg.ErrorExplanations3',
        defaultMessage: 'page for more details or contact',
        description: 'Middle segment of the error support sentence between the doc link and the support contact link'
    },
    ["ErrorExplanations4"]: {
        id: 'ui-notices.msg.ErrorExplanations4',
        defaultMessage: 'ThinkTilt Support',
        description: 'Link text for the ThinkTilt support team, shown as part of an error support message'
    }
});

});


parcelRegister("iSMR0", function(module, exports) {
$parcel$export(module.exports, "constructApiError", () => $9ccb540e46ce9cf7$export$4fb8f0e1418096d0);

var $1YJEf = parcelRequire("1YJEf");

var $kfdvC = parcelRequire("kfdvC");
function $9ccb540e46ce9cf7$export$4fb8f0e1418096d0(error, status, responseJson, requestName, context, contextId, details, isClientFetchError, traceId) {
    switch(error){
        case (0, $1YJEf.ApiErrorType).client:
            return {
                error: (0, $1YJEf.ApiErrorType).client,
                isClientFetchError: isClientFetchError,
                traceId: traceId,
                status: status,
                requestName: requestName
            };
        case (0, $1YJEf.ApiErrorType).clientWithDetails:
            return {
                error: (0, $1YJEf.ApiErrorType).clientWithDetails,
                context: (0, $kfdvC.ErrorContextOf)(context),
                details: details || '',
                isClientFetchError: isClientFetchError,
                traceId: traceId,
                status: status,
                requestName: requestName
            };
        case (0, $1YJEf.ApiErrorType).json:
            return {
                error: (0, $1YJEf.ApiErrorType).json,
                details: details || '',
                isClientFetchError: isClientFetchError,
                traceId: traceId,
                status: status,
                requestName: requestName
            };
        case (0, $1YJEf.ApiErrorType).jwt:
            return {
                error: (0, $1YJEf.ApiErrorType).jwt,
                details: details || '',
                isClientFetchError: isClientFetchError,
                traceId: traceId,
                status: status,
                requestName: requestName
            };
        default:
            return {
                error: (0, $1YJEf.ApiErrorType).unknown,
                message: error,
                status: status,
                responseJson: responseJson,
                isClientFetchError: isClientFetchError,
                traceId: traceId,
                requestName: requestName
            };
    }
}
const $9ccb540e46ce9cf7$export$a072859f46abbb91 = (apiError)=>apiError.error === (0, $1YJEf.ApiErrorType).unknown;
const $9ccb540e46ce9cf7$export$ed98b2247c52f4f6 = (apiError)=>{
    if ($9ccb540e46ce9cf7$export$a072859f46abbb91(apiError) && apiError.status === 400) return {
        generalErrors: [],
        errorsByQuestionId: {},
        ...apiError.responseJson
    };
    return undefined;
};
const $9ccb540e46ce9cf7$export$e6390e344b33daed = (apiError)=>{
    if ($9ccb540e46ce9cf7$export$a072859f46abbb91(apiError) && apiError.status >= 400 && apiError.status < 500) return {
        errorMessages: [],
        errors: {},
        ...apiError.responseJson
    };
    return undefined;
};

});
parcelRegister("1YJEf", function(module, exports) {
$parcel$export(module.exports, "ApiErrorType", () => $87c5fd4cb1b74a64$export$eb26b24d7b7bab09);
var $87c5fd4cb1b74a64$export$eb26b24d7b7bab09 = /*#__PURE__*/ function(ApiErrorType) {
    ApiErrorType["client"] = "client";
    ApiErrorType["clientWithDetails"] = "clientWithDetails";
    ApiErrorType["json"] = "json";
    ApiErrorType["jwt"] = "jwt";
    ApiErrorType["unknown"] = "unknown";
    ApiErrorType["timeout"] = "timeout";
    return ApiErrorType;
}({});

});

parcelRegister("kfdvC", function(module, exports) {
$parcel$export(module.exports, "ErrorContextOf", () => $ee8ff2c1c9b1a3a3$export$2c172aed648e926c);
var $ee8ff2c1c9b1a3a3$export$21818dff4f4f7174 = /*#__PURE__*/ function(ErrorContext) {
    ErrorContext["I18nAccessPathKey"] = "err.access.path";
    ErrorContext["I18nEntityConnectionKey"] = "err.entity.connection";
    ErrorContext["I18nEntityFormKey"] = "err.entity.form";
    ErrorContext["I18nEntityIssueKey"] = "err.entity.issue";
    ErrorContext["I18nEntityIssueCreateKey"] = "err.entity.issue.create";
    ErrorContext["I18nEntityPreferredFormKey"] = "err.entity.preferredform";
    ErrorContext["I18nEntityProjectKey"] = "err.entity.project";
    ErrorContext["I18nEntityRequestTypeKey"] = "err.entity.requesttype";
    ErrorContext["I18nEntityServiceDeskKey"] = "err.entity.servicedesk";
    ErrorContext["I18nJwtParseKey"] = "err.jwt.parse";
    ErrorContext["I18nJwtSignatureKey"] = "err.jwt.signed";
    ErrorContext["I18nJwtVerifyKey"] = "err.jwt.verify";
    ErrorContext["I18nInternalServerError"] = "err.server.internal";
    ErrorContext["I18nUnknownContextError"] = "err.context.unknown";
    return ErrorContext;
}({});
function $ee8ff2c1c9b1a3a3$export$2c172aed648e926c(context) {
    switch(context){
        case "err.access.path":
            return "err.access.path";
        case "err.entity.connection":
            return "err.entity.connection";
        case "err.entity.form":
            return "err.entity.form";
        case "err.entity.issue":
            return "err.entity.issue";
        case "err.entity.issue.create":
            return "err.entity.issue.create";
        case "err.entity.preferredform":
            return "err.entity.preferredform";
        case "err.entity.project":
            return "err.entity.project";
        case "err.entity.requesttype":
            return "err.entity.requesttype";
        case "err.entity.servicedesk":
            return "err.entity.servicedesk";
        case "err.jwt.parse":
            return "err.jwt.parse";
        case "err.jwt.signed":
            return "err.jwt.signed";
        case "err.jwt.verify":
            return "err.jwt.verify";
        case "err.server.internal":
            return "err.server.internal";
        default:
            return "err.context.unknown";
    }
}

});



parcelRegister("e59kp", function(module, exports) {
$parcel$export(module.exports, "setNoticeLocale", () => $31759a1a2383f50d$export$caf904df61b5b10d);

var $bSJIT = parcelRequire("bSJIT");

var $4Sf72 = parcelRequire("4Sf72");

var $ltkSJ = parcelRequire("ltkSJ");

var $gdUUy = parcelRequire("gdUUy");

var $udBpe = parcelRequire("udBpe");
const $31759a1a2383f50d$var$reactRoots = new WeakMap();
/** Mounts `element` with React 18/19 when `nike_r19_render_unmount_2` is on, else uses legacy ReactDOM.render. */ const $31759a1a2383f50d$var$renderToMountPoint = (element, mountPoint)=>{
    if ((0, $gdUUy.fg)('nike_r19_render_unmount_2')) {
        let root = $31759a1a2383f50d$var$reactRoots.get(mountPoint);
        if (!root) {
            root = (0, $ltkSJ.createRoot)(mountPoint);
            $31759a1a2383f50d$var$reactRoots.set(mountPoint, root);
        }
        root.render(element);
    } else (0, (/*@__PURE__*/$parcel$interopDefault($4Sf72))).render(element, mountPoint);
};
/** Unmounts with React 18/19 when `nike_r19_render_unmount_2` is on, else uses legacy ReactDOM.unmountComponentAtNode. */ const $31759a1a2383f50d$var$unmountFromMountPoint = (mountPoint)=>{
    if ((0, $gdUUy.fg)('nike_r19_render_unmount_2')) {
        const root = $31759a1a2383f50d$var$reactRoots.get(mountPoint);
        if (root) {
            root.unmount();
            $31759a1a2383f50d$var$reactRoots.delete(mountPoint);
            return true;
        }
        return false;
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($4Sf72))).unmountComponentAtNode(mountPoint);
};
let $31759a1a2383f50d$var$locale = 'en-US';
function $31759a1a2383f50d$export$caf904df61b5b10d(newLocale) {
    $31759a1a2383f50d$var$locale = newLocale;
}
function $31759a1a2383f50d$export$b25305d7fdb340d7(noticeType, intlValues, errorDetails) {
    return new Promise((resolve)=>{
        const dialogTargetNode = document.getElementById('pf-dialog-container');
        if (!dialogTargetNode) {
            // eslint-disable-next-line no-console
            console.error(`Could not show notice ${noticeType}. The target Node for the dialog is not available`);
            resolve(false);
            return;
        }
        const handleClose = (confirmed)=>{
            resolve(!!confirmed);
            $31759a1a2383f50d$var$closeNotice();
        };
        $31759a1a2383f50d$var$renderToMountPoint(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $udBpe.Notice), {
            noticeType: noticeType,
            handleClose: handleClose,
            settings: {
                intlValues: intlValues,
                errorDetails: errorDetails,
                customLocale: $31759a1a2383f50d$var$locale
            }
        }), dialogTargetNode);
    });
}
function $31759a1a2383f50d$var$closeNotice() {
    const dialogTargetNode = document.getElementById('pf-dialog-container');
    if (!dialogTargetNode) {
        // eslint-disable-next-line no-console
        console.error(`Could not close notice. The target Node for the dialog is not available`);
        return false;
    }
    const closed = $31759a1a2383f50d$var$unmountFromMountPoint(dialogTargetNode);
    if (!closed) // eslint-disable-next-line no-console
    console.error(`Could not close notice. There is no dialog to unmount`);
    return closed;
}

});
parcelRegister("udBpe", function(module, exports) {
$parcel$export(module.exports, "Notice", () => $7ff3cd728a9d4e78$export$71802e30fd294f61);

var $bSJIT = parcelRequire("bSJIT");

var $gHuYN = parcelRequire("gHuYN");

var $4oaiq = parcelRequire("4oaiq");

var $1eLE3 = parcelRequire("1eLE3");

var $5juzF = parcelRequire("5juzF");
const $7ff3cd728a9d4e78$export$71802e30fd294f61 = ({ noticeType: noticeType, handleClose: handleClose, settings: { customLocale: customLocale = (0, $4oaiq.DEFAULT_LOCALE), intlValues: intlValues, errorDetails: errorDetails, overrideZIndex: overrideZIndex } })=>{
    const notice = (0, $5juzF.Notices)[noticeType];
    if (!notice) {
        // eslint-disable-next-line no-console
        console.error(`Could not show notice, notice type ${noticeType} does not exist`);
        handleClose();
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $gHuYN.PackageIntlProvider), {
        locale: customLocale
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $1eLE3.NoticeDialog), {
        title: notice.title,
        titleVars: intlValues === null || intlValues === void 0 ? void 0 : intlValues.titleVars,
        message: notice.message,
        messageVars: intlValues === null || intlValues === void 0 ? void 0 : intlValues.msgVars,
        confirmText: notice.confirmText,
        confirmLink: notice.confirmLink,
        handleClose: handleClose,
        isErrorNotice: notice.isErrorNotice,
        errorDetails: errorDetails,
        isWarningNotice: notice.isWarningNotice,
        overrideZIndex: overrideZIndex
    }));
};

});
parcelRegister("gHuYN", function(module, exports) {
$parcel$export(module.exports, "PackageIntlProvider", () => $94bcbfca239b3903$export$dfce9acc1b75df7a);

var $bSJIT = parcelRequire("bSJIT");

var $4vLTk = parcelRequire("4vLTk");

var $gPlAD = parcelRequire("gPlAD");

var $l0a9o = parcelRequire("l0a9o");

const $94bcbfca239b3903$export$dfce9acc1b75df7a = ({ children: children, locale: locale })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $gPlAD.ProformaIntlProvider), {
        locale: locale,
        messages: (0, $l0a9o.default)
    }, children);
const $94bcbfca239b3903$export$38662a78c6a3a7ce = (WrappedComponent)=>(props)=>{
        const intl = (0, $4vLTk.default)();
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement($94bcbfca239b3903$export$dfce9acc1b75df7a, {
            locale: intl.locale
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement(WrappedComponent, props));
    };

});
parcelRegister("gPlAD", function(module, exports) {
$parcel$export(module.exports, "ProformaIntlProvider", () => $ac1f8049aafd1672$export$f345b4b8e42e419e);

var $bSJIT = parcelRequire("bSJIT");

var $fK3tS = parcelRequire("fK3tS");
var $dTM5i = parcelRequire("dTM5i");

var $8aT4G = parcelRequire("8aT4G");

var $bMYuu = parcelRequire("bMYuu");
const $ac1f8049aafd1672$export$f345b4b8e42e419e = ({ children: children, locale: locale, messages: messages })=>{
    const { language: language, country: country } = (0, $bMYuu.getCodesFromLocale)(locale) ?? {};
    const lazyMessages = (0, $bMYuu.useLazyMessages)(messages, language ?? (0, $bMYuu.DEFAULT_LOCALE), country);
    // Read an ancestor IntlProvider's messages (if any) so that translations
    // owned by the consumer app remain available to content rendered beneath
    // this provider — notably custom renderers passed into proforma surfaces
    // that call <FormattedMessage /> with consumer-owned ids.
    //
    // We read IntlContext directly rather than using useIntl() because useIntl()
    // throws when there is no ancestor provider, and this component is
    // documented to work standalone. Package-owned messages are spread last so
    // they always win on id collisions, preserving the library's canonical
    // translations.
    const parentIntl = (0, $bSJIT.useContext)((0, $fK3tS.Context));
    const parentMessages = parentIntl === null || parentIntl === void 0 ? void 0 : parentIntl.messages;
    // `IntlProvider` expects a homogeneous Record<string, string> or
    // Record<string, MessageFormatElement[]>. The parent bundle may contain
    // pre-compiled MessageFormatElement[] values, while our lazy bundle is
    // always plain strings; mixing them at the type level is fine at runtime
    // because react-intl handles both per-entry.
    // Hence casting mergedMessages to Record<string, string> is purely done to
    // satisfy Typescript.
    const mergedMessages = (0, $bSJIT.useMemo)(()=>lazyMessages !== undefined ? {
            ...parentMessages ?? {},
            ...lazyMessages
        } : undefined, [
        parentMessages,
        lazyMessages
    ]);
    if (mergedMessages === undefined) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $dTM5i.default), {
        messages: mergedMessages,
        locale: country && `${language}-${country}` || language || locale.replace('_', '-'),
        defaultLocale: (0, $bMYuu.DEFAULT_LOCALE),
        defaultRichTextElements: {
            b: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $8aT4G.Text), {
                    weight: "bold"
                }, chunks),
            strong: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $8aT4G.Text), {
                    as: "strong"
                }, chunks)
        }
    }, children);
};

});
parcelRegister("bMYuu", function(module, exports) {
$parcel$export(module.exports, "DEFAULT_LOCALE", () => $16a85774dc85213f$export$1af4c7e47ad72f44);
$parcel$export(module.exports, "getCodesFromLocale", () => $16a85774dc85213f$export$4d25b49b6dc1b540);
$parcel$export(module.exports, "useLazyMessages", () => $16a85774dc85213f$export$7ddce3b5511cfaa8);

var $bSJIT = parcelRequire("bSJIT");
const $16a85774dc85213f$export$1af4c7e47ad72f44 = 'en';
const $16a85774dc85213f$var$localeRegex = /([a-z]+)(?:[-_]([A-Z]+))?/i;
const $16a85774dc85213f$export$4d25b49b6dc1b540 = (locale)=>{
    const match = $16a85774dc85213f$var$localeRegex.exec(locale);
    if (match) {
        const [, language, country] = match;
        return {
            language: language.toLowerCase(),
            country: country === null || country === void 0 ? void 0 : country.toUpperCase()
        };
    }
    // TODO: Use error service to log:
    // eslint-disable-next-line no-console
    console.error('Unable to determine language and country from invalid locale.');
    return undefined;
};
const $16a85774dc85213f$var$loadLazyMessages = async (lazyMessages, language, country)=>{
    var _await, _ref;
    return ((_await = await ((_ref = country && lazyMessages[`${language}_${country}`] || lazyMessages[language] || lazyMessages.en) === null || _ref === void 0 ? void 0 : _ref())) === null || _await === void 0 ? void 0 : _await.default) ?? {};
};
const $16a85774dc85213f$export$7ddce3b5511cfaa8 = (lazyMessages, language, country)=>{
    const [messages, setMessages] = (0, $bSJIT.useState)();
    (0, $bSJIT.useEffect)(()=>{
        $16a85774dc85213f$var$loadLazyMessages(lazyMessages, language, country).catch(()=>({})).then(setMessages);
    }, [
        country,
        language,
        lazyMessages,
        setMessages
    ]);
    return messages;
};

});


parcelRegister("l0a9o", function(module, exports) {
$parcel$export(module.exports, "default", () => $0df92dd791ea3f85$export$2e2bcd8739ae039);
/**
 * NOTE:
 *
 * This file is automatically generated.
 * DO NOT UPDATE IT BY HAND. Instead, run yarn generate-i18n-index in @atlassian/proforma-utils.
 */ 
























const $0df92dd791ea3f85$var$lazyMessages = {
    cs: ()=>(parcelRequire("5zl88")),
    da: ()=>(parcelRequire("9DFh9")),
    de: ()=>(parcelRequire("bLNXU")),
    en: ()=>(parcelRequire("ebZmQ")),
    en_GB: ()=>(parcelRequire("3uLo3")),
    en_ZZ: ()=>(parcelRequire("2K5pz")),
    es: ()=>(parcelRequire("eY8Ed")),
    fi: ()=>(parcelRequire("DVLJo")),
    fr: ()=>(parcelRequire("6Vsiv")),
    hu: ()=>(parcelRequire("jRUvc")),
    it: ()=>(parcelRequire("5nTlu")),
    ja: ()=>(parcelRequire("8rTA0")),
    ko: ()=>(parcelRequire("6MnpF")),
    nb: ()=>(parcelRequire("28B0c")),
    nl: ()=>(parcelRequire("2UrPK")),
    pl: ()=>(parcelRequire("hBi9p")),
    pt_BR: ()=>(parcelRequire("j50Wt")),
    ru: ()=>(parcelRequire("iRbaO")),
    sv: ()=>(parcelRequire("cGzPP")),
    th: ()=>(parcelRequire("1D61t")),
    tr: ()=>(parcelRequire("gygFz")),
    uk: ()=>(parcelRequire("gpnwq")),
    vi: ()=>(parcelRequire("bcfhR")),
    zh: ()=>(parcelRequire("lrWyw")),
    zh_TW: ()=>(parcelRequire("fC2ep"))
};
var $0df92dd791ea3f85$export$2e2bcd8739ae039 = $0df92dd791ea3f85$var$lazyMessages;

});
parcelRegister("5zl88", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = $kOunM("6G5VQ").then(()=>parcelRequire('kK1i0'));

});
parcelRegister("kOunM", function(module, exports) {
"use strict";

function $f2700b8349aa6afb$var$load(id) {
    // eslint-disable-next-line no-undef
    return import((parcelRequire("gBxz7")).resolve(id));
}
module.exports = $f2700b8349aa6afb$var$load;

});
parcelRegister("gBxz7", function(module, exports) {
$parcel$export(module.exports, "register", () => $c16a23763a54f59d$export$6503ec6e8aabbaf, (v) => $c16a23763a54f59d$export$6503ec6e8aabbaf = v);
$parcel$export(module.exports, "resolve", () => $c16a23763a54f59d$export$f7ad0328861e2f03, (v) => $c16a23763a54f59d$export$f7ad0328861e2f03 = v);
var $c16a23763a54f59d$export$6503ec6e8aabbaf;
var $c16a23763a54f59d$export$f7ad0328861e2f03;
"use strict";
var $c16a23763a54f59d$var$mapping = new Map();
function $c16a23763a54f59d$var$register(/** @type {string} */ baseUrl, /** @type {Array<string>} */ manifest // ['id', 'path', 'id2', 'path2']
) {
    for(var i = 0; i < manifest.length - 1; i += 2)$c16a23763a54f59d$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $c16a23763a54f59d$var$resolve(id) {
    var resolved = $c16a23763a54f59d$var$mapping.get(id);
    if (resolved == null) throw new Error('Could not resolve bundle with id ' + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$c16a23763a54f59d$export$6503ec6e8aabbaf = $c16a23763a54f59d$var$register;
$c16a23763a54f59d$export$f7ad0328861e2f03 = $c16a23763a54f59d$var$resolve;

});



parcelRegister("9DFh9", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = $kOunM("cAAmb").then(()=>parcelRequire('i1Ynv'));

});

parcelRegister("bLNXU", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = $kOunM("lp1sb").then(()=>parcelRequire('d9Mfx'));

});

parcelRegister("ebZmQ", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = $kOunM("faG4X").then(()=>parcelRequire('hz0sl'));

});

parcelRegister("3uLo3", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = $kOunM("kO0AV").then(()=>parcelRequire('dAgOj'));

});

parcelRegister("2K5pz", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = $kOunM("5eimR").then(()=>parcelRequire('7T8Y9'));

});

parcelRegister("eY8Ed", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = $kOunM("bMFx2").then(()=>parcelRequire('cSpZc'));

});

parcelRegister("DVLJo", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = $kOunM("7MXhD").then(()=>parcelRequire('7Ub8D'));

});

parcelRegister("6Vsiv", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = $kOunM("5bepp").then(()=>parcelRequire('hwyLa'));

});

parcelRegister("jRUvc", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = $kOunM("h48sF").then(()=>parcelRequire('cbVpW'));

});

parcelRegister("5nTlu", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = $kOunM("3lbmW").then(()=>parcelRequire('5oqj3'));

});

parcelRegister("8rTA0", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = $kOunM("65kV9").then(()=>parcelRequire('gReEY'));

});

parcelRegister("6MnpF", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = $kOunM("aZKSC").then(()=>parcelRequire('6zlbL'));

});

parcelRegister("28B0c", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = $kOunM("aP0Gh").then(()=>parcelRequire('2iaoz'));

});

parcelRegister("2UrPK", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = $kOunM("83GxO").then(()=>parcelRequire('fPss1'));

});

parcelRegister("hBi9p", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = $kOunM("4EHPk").then(()=>parcelRequire('6Ji9B'));

});

parcelRegister("j50Wt", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = $kOunM("g6KuG").then(()=>parcelRequire('8pq3v'));

});

parcelRegister("iRbaO", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = $kOunM("aV8Sl").then(()=>parcelRequire('gGnwa'));

});

parcelRegister("cGzPP", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = $kOunM("bvTkT").then(()=>parcelRequire('jJBNY'));

});

parcelRegister("1D61t", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = $kOunM("25CVn").then(()=>parcelRequire('eBM0G'));

});

parcelRegister("gygFz", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = $kOunM("dzizB").then(()=>parcelRequire('gcTJS'));

});

parcelRegister("gpnwq", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = $kOunM("gtWuV").then(()=>parcelRequire('49uUg'));

});

parcelRegister("bcfhR", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = $kOunM("ciyBK").then(()=>parcelRequire('iaB4e'));

});

parcelRegister("lrWyw", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = $kOunM("17N7A").then(()=>parcelRequire('1Okg8'));

});

parcelRegister("fC2ep", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = $kOunM("dHSR9").then(()=>parcelRequire('jGOdP'));

});



parcelRegister("4oaiq", function(module, exports) {
$parcel$export(module.exports, "DEFAULT_LOCALE", () => $ae9ab3d55a368234$export$1af4c7e47ad72f44);

var $bSJIT = parcelRequire("bSJIT");

var $dTM5i = parcelRequire("dTM5i");
var $4vLTk = parcelRequire("4vLTk");

var $8aT4G = parcelRequire("8aT4G");

var $l0a9o = parcelRequire("l0a9o");

var $jGX1v = parcelRequire("jGX1v");
const $ae9ab3d55a368234$export$1af4c7e47ad72f44 = 'en-US';
const $ae9ab3d55a368234$export$23e25b3437f9c000 = ({ children: children, i18nMessages: i18nMessages, locale: locale })=>{
    // `commonCoreI18nMessages` is a temporary variable required only while we need to maintain
    // access to the 'proforma-common-core' translations for other packages. Once the translations
    // are properly per package, this can be removed.
    const commonCoreI18nMessages = (0, $jGX1v.useLazyI18nMessages)(locale, (0, $l0a9o.default));
    if (!commonCoreI18nMessages) return null;
    const { language: language, country: country } = (0, $jGX1v.getCodesFromLocale)(locale);
    const messages = (country && i18nMessages[`${language}_${country}`]) ?? i18nMessages[language] ?? i18nMessages.en;
    // `aggregateMessages` is a temporary variable required only while we need to maintain
    // access to the 'proforma-common-core' translations for other packages. Once the translations
    // are properly per package, this can be removed.
    const aggregateMessages = {
        ...commonCoreI18nMessages,
        ...messages
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $dTM5i.default), {
        messages: aggregateMessages,
        locale: country ? `${language}-${country}` : language,
        defaultLocale: $ae9ab3d55a368234$export$1af4c7e47ad72f44,
        defaultRichTextElements: {
            b: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $8aT4G.Text), {
                    weight: "bold"
                }, chunks),
            strong: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $8aT4G.Text), {
                    as: "strong"
                }, chunks)
        }
    }, children);
};
const $ae9ab3d55a368234$export$a98a2d834cadecf0 = (i18nMessages, WrappedComponent)=>(props)=>{
        const intl = (0, $4vLTk.default)();
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement($ae9ab3d55a368234$export$23e25b3437f9c000, {
            i18nMessages: i18nMessages,
            locale: intl.locale
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement(WrappedComponent, props));
    };

});
parcelRegister("jGX1v", function(module, exports) {
$parcel$export(module.exports, "getCodesFromLocale", () => $1a6ec91d5dd0f30b$export$4d25b49b6dc1b540);
$parcel$export(module.exports, "useLazyI18nMessages", () => $1a6ec91d5dd0f30b$export$30a7082641f381ea);

var $bSJIT = parcelRequire("bSJIT");

var $4oaiq = parcelRequire("4oaiq");
const $1a6ec91d5dd0f30b$var$localeRegex = /([a-z]+)(?:[-_]([A-Z]+))?/i;
const $1a6ec91d5dd0f30b$export$4d25b49b6dc1b540 = (locale)=>{
    let match = $1a6ec91d5dd0f30b$var$localeRegex.exec(locale);
    if (!match) {
        // eslint-disable-next-line no-console
        console.error('Unable to get language and country from invalid locale, falling back to default locale.');
        match = $1a6ec91d5dd0f30b$var$localeRegex.exec((0, $4oaiq.DEFAULT_LOCALE));
    }
    const [, language, country] = match;
    return {
        language: language.toLowerCase(),
        country: country === null || country === void 0 ? void 0 : country.toUpperCase()
    };
};
const $1a6ec91d5dd0f30b$var$loadLazyI18nMessages = async (locale, lazyI18nMessages)=>{
    var _await, _ref;
    const { language: language, country: country } = $1a6ec91d5dd0f30b$export$4d25b49b6dc1b540(locale);
    return ((_await = await ((_ref = country && lazyI18nMessages[`${language}_${country}`] || lazyI18nMessages[language] || lazyI18nMessages.en) === null || _ref === void 0 ? void 0 : _ref())) === null || _await === void 0 ? void 0 : _await.default) ?? {};
};
const $1a6ec91d5dd0f30b$export$30a7082641f381ea = (locale, lazyI18nMessages)=>{
    const [messages, setMessages] = (0, $bSJIT.useState)();
    (0, $bSJIT.useEffect)(()=>{
        $1a6ec91d5dd0f30b$var$loadLazyI18nMessages(locale, lazyI18nMessages).catch(()=>({})).then(setMessages);
    }, [
        locale,
        setMessages,
        lazyI18nMessages
    ]);
    return messages;
};

});


parcelRegister("1eLE3", function(module, exports) {
$parcel$export(module.exports, "NoticeDialog", () => $38991aa7bec62293$export$7ccde09c2c5f5940);

var $bSJIT = parcelRequire("bSJIT");

var $5cKiX = parcelRequire("5cKiX");

var $hzFIQ = parcelRequire("hzFIQ");

var $2w1u7 = parcelRequire("2w1u7");

var $c9mVs = parcelRequire("c9mVs");

var $7HzAO = parcelRequire("7HzAO");

var $j4mCC = parcelRequire("j4mCC");

var $4TlNm = parcelRequire("4TlNm");

var $8aT4G = parcelRequire("8aT4G");

var $3102O = parcelRequire("3102O");

var $gFa5g = parcelRequire("gFa5g");

var $5Pv4s = parcelRequire("5Pv4s");
const $38991aa7bec62293$export$7ccde09c2c5f5940 = ({ title: title, titleVars: titleVars, message: message, messageVars: messageVars, confirmText: confirmText, confirmLink: confirmLink, handleClose: handleClose, isErrorNotice: isErrorNotice, errorDetails: errorDetails, isWarningNotice: isWarningNotice, overrideZIndex: overrideZIndex })=>{
    const appearance = isErrorNotice ? 'danger' : isWarningNotice ? 'warning' : undefined;
    const actions = [];
    if (isErrorNotice) ;
    else if (confirmLink) actions.push({
        text: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $5cKiX.default), (0, $5Pv4s.IntlNoticeMessages)[(0, $5Pv4s.NoticeMessage).Close]),
        onClick: ()=>handleClose(false),
        appearance: 'subtle'
    });
    else actions.push({
        text: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $5cKiX.default), (0, $5Pv4s.IntlNoticeMessages)[(0, $5Pv4s.NoticeMessage).Cancel]),
        onClick: ()=>handleClose(false),
        appearance: 'subtle'
    });
    const primaryButtonAppearance = appearance || 'primary';
    if (confirmLink) actions.push({
        text: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $5cKiX.default), confirmText),
        href: confirmLink,
        target: '_blank',
        rel: 'noopener noreferrer',
        appearance: primaryButtonAppearance
    });
    else actions.push({
        text: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $5cKiX.default), confirmText),
        onClick: ()=>handleClose(true),
        appearance: primaryButtonAppearance
    });
    let onOpenCompleteF;
    if (overrideZIndex) onOpenCompleteF = (node, isAppearing)=>{
        // oxlint-disable-next-line no-param-reassign, no-unused-expressions
        overrideZIndex && node.parentElement ? node.parentElement.style.zIndex = '5000' : undefined;
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $c9mVs.default), {
        onOpenComplete: onOpenCompleteF,
        onClose: ()=>handleClose(),
        shouldCloseOnOverlayClick: false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $j4mCC.default), {
        hasCloseButton: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $4TlNm.default), {
        appearance: appearance
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $5cKiX.default), {
        ...title,
        values: titleVars
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $2w1u7.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $5cKiX.default), {
        ...message,
        values: messageVars
    })), isErrorNotice && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $8aT4G.Text), {
        as: "p"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $5cKiX.default), (0, $5Pv4s.IntlNoticeMessages)[(0, $5Pv4s.NoticeMessage).ErrorExplanations1]), ' ', /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $3102O.PfLink), {
        href: "http://links.thinktilt.net/error-explanations"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $5cKiX.default), (0, $5Pv4s.IntlNoticeMessages)[(0, $5Pv4s.NoticeMessage).ErrorExplanations2])), ' ', /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $5cKiX.default), (0, $5Pv4s.IntlNoticeMessages)[(0, $5Pv4s.NoticeMessage).ErrorExplanations3]), ' ', /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $3102O.PfLink), {
        href: "https://support.thinktilt.com/"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $5cKiX.default), (0, $5Pv4s.IntlNoticeMessages)[(0, $5Pv4s.NoticeMessage).ErrorExplanations4])), "."), !!errorDetails && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $gFa5g.ErrorSection), {
        errorDetails: errorDetails
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $7HzAO.default), null, actions.map(({ text: text, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $hzFIQ.default), props, text))));
};

});
parcelRegister("3102O", function(module, exports) {
$parcel$export(module.exports, "PfLink", () => $96b70fe20bf127f2$export$9522c077a5f2be27);

var $bSJIT = parcelRequire("bSJIT");

var $9Rfip = parcelRequire("9Rfip");
const $96b70fe20bf127f2$export$9522c077a5f2be27 = ({ href: href, onClick: onClick, id: id, popup: popup = true, children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $9Rfip.default), {
        href: href,
        id: id,
        rel: popup ? 'noreferrer noopener' : undefined,
        target: popup ? '_blank' : undefined,
        onClick: onClick
    }, children);

});

parcelRegister("gFa5g", function(module, exports) {
$parcel$export(module.exports, "ErrorSection", () => $1a50af6186f665f5$export$b0bceea2ea86179a);

var $bSJIT = parcelRequire("bSJIT");

var $8aT4G = parcelRequire("8aT4G");

var $eidO5 = parcelRequire("eidO5");

var $9KQKC = parcelRequire("9KQKC");
function $1a50af6186f665f5$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $1a50af6186f665f5$export$b0bceea2ea86179a = ({ errorDetails: errorDetails })=>{
    const [showErrorDetails, setShowErrorDetails] = (0, $bSJIT.useState)(false);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement($1a50af6186f665f5$var$ErrorSectionLabel, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $8aT4G.Text), {
        as: "p"
    }, "Show error details:"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $eidO5.default), {
        isChecked: showErrorDetails,
        onChange: ()=>{
            setShowErrorDetails(!showErrorDetails);
        }
    })), showErrorDetails && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement($1a50af6186f665f5$var$ErrorDetailsWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement("code", null, errorDetails)));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $1a50af6186f665f5$var$ErrorSectionLabel = /*#__PURE__*/ (0, $9KQKC.default)("div", {
    target: "e1ouavgh1"
})({
    name: "anec9d",
    styles: "display:flex;margin-top:var(--ds-space-250, 20px);> p{margin-top:var(--ds-space-025, 2px);}"
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $1a50af6186f665f5$var$ErrorDetailsWrapper = /*#__PURE__*/ (0, $9KQKC.default)("div", {
    target: "e1ouavgh0"
})({
    name: "1yhr4n3",
    styles: "background-color:var(--ds-background-neutral, #0515240F);padding:var(--ds-space-100, 8px);font:var(--ds-font-body-small, normal 400 12px/16px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)"
});

});




parcelRegister("6LVpS", function(module, exports) {
$parcel$export(module.exports, "LiveErrorUtils", () => $9435c73babd48789$export$f2a509cffb92cb9c);
/* eslint-disable no-console */ 
var $bSJIT = parcelRequire("bSJIT");

var $ibPGb = parcelRequire("ibPGb");
var $iSbcz = parcelRequire("iSbcz");
var $icZGb = parcelRequire("icZGb");

var $5cKiX = parcelRequire("5cKiX");

var $9hihM = parcelRequire("9hihM");

var $hkLEY = parcelRequire("hkLEY");

var $k2MWg = parcelRequire("k2MWg");

var $429NB = parcelRequire("429NB");

var $3zmW4 = parcelRequire("3zmW4");

var $5juzF = parcelRequire("5juzF");

var $8dotP = parcelRequire("8dotP");
// structured tags that we send to Sentry
// everything else from details object will go into "extras"
const $9435c73babd48789$var$TAGS = [
    'module',
    'actionSubject',
    'url',
    'isProformaLocalConsumption'
];
// From https://sentry.io/settings/atlassian-2y/projects/proforma/keys/
const $9435c73babd48789$var$SENTRY_PUBLIC_KEY = 'c6ac6cc7ef554e3286ec09d412c9c1f4';
const $9435c73babd48789$var$SENTRY_PROJECT_ID = '6388218';
const $9435c73babd48789$var$SENTRY_COMMERCIAL_DSN = `https://${$9435c73babd48789$var$SENTRY_PUBLIC_KEY}@o55978.ingest.sentry.io/${$9435c73babd48789$var$SENTRY_PROJECT_ID}`;
const $9435c73babd48789$var$SENTRY_FEDRAMP_DSN = `https://${$9435c73babd48789$var$SENTRY_PUBLIC_KEY}@sentry.atlassian-us-gov-mod.com/${$9435c73babd48789$var$SENTRY_PROJECT_ID}`;
const $9435c73babd48789$var$PROFORMA_SENTRY_PROJECT_DSN = (0, $9hihM.isFedRamp)() ? $9435c73babd48789$var$SENTRY_FEDRAMP_DSN : $9435c73babd48789$var$SENTRY_COMMERCIAL_DSN;
class $9435c73babd48789$export$f2a509cffb92cb9c {
    constructor(moduleName, showFlag, createAnalyticsEvent, environment){
        this.moduleName = moduleName;
        this.showFlag = showFlag;
        this.createAnalyticsEvent = createAnalyticsEvent;
        this.environment = environment;
        this.sentryHub = this.getSentryHub(environment);
    }
    reportError(error, options) {
        const errorPrefix = `Proforma(${this.moduleName}): `;
        const severity = options !== null && options !== void 0 && options.severity ? options.severity : (0, $icZGb.Severity).Error;
        // 1) Log error in console
        switch(severity){
            case (0, $icZGb.Severity).Warning:
                console.warn(errorPrefix, error);
                break;
            case (0, $icZGb.Severity).Info:
                console.info(errorPrefix, error);
                break;
            default:
                console.error(errorPrefix, error);
                break;
        }
        const actionSubject = (options === null || options === void 0 ? void 0 : options.actionSubject) ?? (0, $429NB.ActionSubject).PROFORMA_UI;
        const attributes = (options === null || options === void 0 ? void 0 : options.attributes) && Object.fromEntries(Object.entries(options.attributes).map(([key, value])=>[
                key,
                typeof value === 'string' ? (0, $3zmW4.maskEmailIds)(value) : value
            ]));
        // Todo: add user agent, package version, url,
        const details = {
            actionSubject: actionSubject,
            errorId: options === null || options === void 0 ? void 0 : options.id,
            severity: severity,
            module: this.moduleName,
            errorMsg: error.message,
            errorInfo: options === null || options === void 0 ? void 0 : options.errorInfo,
            isClientFetchError: error.isClientFetchError,
            requestName: error.requestName,
            traceId: error.traceId,
            status: error.status,
            userAgent: this.getBrowserUserAgent(),
            url: this.getUrl(),
            ...attributes
        };
        // 2) Send error to Atlassian analytics pipeline (GasV3)
        (0, $k2MWg.fireOperationalAnalytics)(this.createAnalyticsEvent({}), `${actionSubject} ${(0, $429NB.Action).FAILED}`, details);
        // 3) Send error to Sentry
        if (this.environment === (0, $8dotP.Environment).LOCAL || this.sentryHub === undefined) return;
        // oxlint-disable-next-line prefer-destructuring
        const sentryHub = this.sentryHub;
        sentryHub.withScope((scope)=>{
            scope.setLevel(severity);
            Object.keys(details).forEach((key)=>{
                const value = details[key];
                if (value) {
                    if ($9435c73babd48789$var$TAGS.includes(key)) scope.setTag(key, value.toString());
                    else scope.setExtra(key, value);
                }
            });
            sentryHub.captureException(error);
        });
    }
    /**
   * @private
   * @deprecated notifyUser has been deprecated. Please use the `useFlags()` hook directly instead.
   */ notifyUser(errorNotice, customDescription) {
        const notice = (0, $5juzF.Notices)[errorNotice];
        if (notice) {
            this.showFlag({
                appearance: 'error',
                isAutoDismiss: true,
                icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($hkLEY))), {
                    label: "",
                    color: "var(--ds-icon-inverse, #FFFFFF)"
                }),
                title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $5cKiX.default), notice.title),
                description: customDescription ? customDescription : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $5cKiX.default), notice.message)
            });
            return Promise.resolve();
        } else {
            console.error(`Could not show error, notice type ${errorNotice} does not exist`);
            return Promise.reject();
        }
    }
    getSentryHub(environment) {
        try {
            const client = new (0, $ibPGb.BrowserClient)({
                environment: environment,
                dsn: $9435c73babd48789$var$PROFORMA_SENTRY_PROJECT_DSN
            });
            return new (0, $iSbcz.Hub)(client);
        } catch (error) {
            const actionSubject = 'getProformaSentryHub';
            const details = {
                actionSubject: actionSubject,
                severity: (0, $icZGb.Severity).Error,
                module: this.moduleName,
                errorMsg: error.message,
                userAgent: this.getBrowserUserAgent(),
                url: this.getUrl()
            };
            (0, $k2MWg.fireOperationalAnalytics)(this.createAnalyticsEvent({}), `${actionSubject} ${(0, $429NB.Action).FAILED}`, details);
        }
    }
    getBrowserUserAgent() {
        var _window;
        return ((_window = window) === null || _window === void 0 || (_window = _window.navigator) === null || _window === void 0 ? void 0 : _window.userAgent) ?? 'unknown';
    }
    getUrl() {
        var _window2;
        return ((_window2 = window) === null || _window2 === void 0 || (_window2 = _window2.document) === null || _window2 === void 0 || (_window2 = _window2.location) === null || _window2 === void 0 ? void 0 : _window2.host) ?? 'unknown';
    }
}

});
parcelRegister("3zmW4", function(module, exports) {
$parcel$export(module.exports, "maskEmailIds", () => $4ce415bb3ea92b04$export$7a75efd77ad928b4);
const $4ce415bb3ea92b04$var$EMAIL_REGEX = /([a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,})/gi;
const $4ce415bb3ea92b04$export$7a75efd77ad928b4 = (text)=>text.replace($4ce415bb3ea92b04$var$EMAIL_REGEX, '***@***');

});



parcelRegister("h5lZ1", function(module, exports) {
$parcel$export(module.exports, "useShowNotice", () => $cffd41e55123a0b6$export$6935f0f6f663b91f);
$parcel$export(module.exports, "NoticeProvider", () => $cffd41e55123a0b6$export$a9b49e4ddf9e18db);

var $bSJIT = parcelRequire("bSJIT");

var $hzFIQ = parcelRequire("hzFIQ");

var $2w1u7 = parcelRequire("2w1u7");

var $c9mVs = parcelRequire("c9mVs");

var $7HzAO = parcelRequire("7HzAO");

var $j4mCC = parcelRequire("j4mCC");

var $4TlNm = parcelRequire("4TlNm");
const $cffd41e55123a0b6$var$ShowNoticeContext = /*#__PURE__*/ (0, $bSJIT.createContext)(undefined);
const $cffd41e55123a0b6$export$6935f0f6f663b91f = ()=>{
    const noticeApi = (0, $bSJIT.useContext)($cffd41e55123a0b6$var$ShowNoticeContext);
    if (!noticeApi) throw Error('Hook must be used in a NoticeProvider');
    return noticeApi;
};
const $cffd41e55123a0b6$export$a9b49e4ddf9e18db = ({ children: children })=>{
    const [notice, setNotice] = (0, $bSJIT.useState)();
    const onCloseHandler = ()=>{
        setNotice(undefined);
        if (notice && notice.onCloseHandler) notice.onCloseHandler();
    };
    const onConfirmHandler = ()=>{
        setNotice(undefined);
        if (notice && notice.onConfirmHandler) notice.onConfirmHandler();
    };
    const noticeApi = (0, $bSJIT.useMemo)(()=>({
            showNotice: (props)=>{
                setNotice(props);
            }
        }), []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement($cffd41e55123a0b6$var$ShowNoticeContext.Provider, {
        value: noticeApi
    }, children), notice && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement($cffd41e55123a0b6$export$71802e30fd294f61, {
        ...notice,
        onCloseHandler: onCloseHandler,
        onConfirmHandler: onConfirmHandler
    }));
};
const $cffd41e55123a0b6$export$71802e30fd294f61 = ({ appearance: appearance, title: title, body: body, closeText: closeText, onCloseHandler: onCloseHandler, confirmText: confirmText, onConfirmHandler: onConfirmHandler })=>{
    const actions = [];
    const primaryButtonAppearance = appearance || 'primary';
    if (confirmText && onConfirmHandler) {
        actions.push({
            key: 'pf-notice-secondary-button',
            appearance: 'subtle',
            onClick: onCloseHandler,
            text: closeText
        });
        actions.push({
            key: 'pf-notice-primary-button',
            appearance: primaryButtonAppearance,
            onClick: onConfirmHandler,
            text: confirmText,
            testId: 'show-notice-confirm-btn'
        });
    } else actions.push({
        key: 'pf-notice-primary-button',
        appearance: primaryButtonAppearance,
        onClick: onCloseHandler,
        text: closeText,
        testId: 'show-notice-close-btn'
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $c9mVs.default), {
        shouldCloseOnOverlayClick: false,
        onClose: onCloseHandler,
        testId: "show-notice-dialog"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $j4mCC.default), {
        hasCloseButton: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $4TlNm.default), {
        appearance: appearance
    }, title)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $2w1u7.default), null, body), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $7HzAO.default), null, actions.map(({ key: key, text: text, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $hzFIQ.default), {
            key: key,
            ...props
        }, text))));
};

});

parcelRegister("hcE22", function(module, exports) {
$parcel$export(module.exports, "AnalyticsProvider", () => $e31e841474db8a52$export$1b581a2ec13e37f1);

var $bSJIT = parcelRequire("bSJIT");

var $1w9as = parcelRequire("1w9as");

var $clpci = parcelRequire("clpci");
const $e31e841474db8a52$export$1b581a2ec13e37f1 = ({ children: children, channel: channel })=>{
    const sendEvent = (0, $bSJIT.useCallback)((event)=>{
        var _event$clone;
        // For backwards compatibility with analytics listeners in the product
        // which attempt to determine the actionSubject and attributes
        // from the context.
        const { actionSubject: actionSubject, attributes: attributes } = event.payload;
        const context = {};
        if (actionSubject) {
            context.component = actionSubject;
            context.componentName = actionSubject;
        }
        if (attributes) context.attributes = attributes;
        event.context.push(context);
        (_event$clone = event.clone()) === null || _event$clone === void 0 || _event$clone.fire(channel);
    }, [
        channel
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $1w9as.default), {
        channel: (0, $clpci.ANALYTICS_BRIDGE_CHANNEL),
        onEvent: sendEvent
    }, children);
};

});

parcelRegister("bWiRx", function(module, exports) {
$parcel$export(module.exports, "useService", () => $9dea503372945748$export$6de4685a6c88b4e9);

var $bSJIT = parcelRequire("bSJIT");
const $9dea503372945748$export$6de4685a6c88b4e9 = (request, initialState = {})=>{
    const [state, setState] = (0, $bSJIT.useState)({
        loading: false,
        data: undefined,
        error: undefined,
        ...initialState
    });
    const fetch = (0, $bSJIT.useCallback)(async (requestData)=>{
        setState({
            loading: true,
            error: undefined,
            data: undefined
        });
        try {
            const data = await request(requestData);
            setState({
                data: data,
                loading: false,
                error: undefined
            });
            return data;
        } catch (error) {
            setState({
                error: error,
                loading: false,
                data: undefined
            });
            return Promise.reject(error);
        }
    }, [
        request
    ]);
    return {
        ...state,
        fetch: fetch
    };
};

});

parcelRegister("9z85g", function(module, exports) {
$parcel$export(module.exports, "getRegistrationErrorAttributes", () => $7bdb650f6566c40e$export$67455f71ed23e0f3);
$parcel$export(module.exports, "useManageAttachmentRegistration", () => $7bdb650f6566c40e$export$dd8462123a24729c);

var $bSJIT = parcelRequire("bSJIT");

var $gjxgd = parcelRequire("gjxgd");

var $i86qj = parcelRequire("i86qj");

var $5JwFL = parcelRequire("5JwFL");
const $7bdb650f6566c40e$export$67455f71ed23e0f3 = (error)=>{
    if (typeof error !== 'object' || error === null) return {};
    const message = 'message' in error && typeof error.message === 'string' ? error.message : undefined;
    const status = 'status' in error && (typeof error.status === 'string' || typeof error.status === 'number') ? error.status : undefined;
    const statusCode = 'statusCode' in error && (typeof error.statusCode === 'string' || typeof error.statusCode === 'number') ? error.statusCode : undefined;
    const traceId = 'traceId' in error && typeof error.traceId === 'string' ? error.traceId : undefined;
    return {
        traceId: traceId,
        error: message,
        status: status ?? statusCode
    };
};
const $7bdb650f6566c40e$export$dd8462123a24729c = ()=>{
    const { getFieldValues: getFieldValues, updateModifiedValue: updateModifiedValue } = (0, $5JwFL.usePublicFormRendererActions)();
    return (0, $bSJIT.useCallback)(async (event, register)=>{
        const { fieldId: fieldId } = event;
        const fileId = event.file.identifier.id;
        try {
            await register();
        } catch (error) {
            // Remove the file whose registration failed so it can't be silently submitted.
            const currentValue = (0, $i86qj.asFilesValue)(getFieldValues()[fieldId]);
            const remainingFiles = (currentValue === null || currentValue === void 0 ? void 0 : currentValue.files.filter((file)=>file.identifier.id !== fileId)) ?? [];
            updateModifiedValue(fieldId, remainingFiles.length > 0 ? {
                files: remainingFiles,
                fileStatus: (0, $gjxgd.FileStatus).UPLOADED
            } : null);
            throw error;
        }
    }, [
        getFieldValues,
        updateModifiedValue
    ]);
};

});


//# sourceMappingURL=shared.febff695.js.map
